import { render, staticRenderFns } from "./actuCard.vue?vue&type=template&id=114c6d1d&scoped=true&"
import script from "./actuCard.vue?vue&type=script&lang=js&"
export * from "./actuCard.vue?vue&type=script&lang=js&"
import style0 from "./actuCard.vue?vue&type=style&index=0&id=114c6d1d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "114c6d1d",
  null
  
)

export default component.exports